import { defineComponent as D, mergeModels as N, useModel as j, computed as a, createBlock as d, openBlock as s, unref as v, mergeProps as g, withModifiers as L, withCtx as z, createElementVNode as o, createCommentVNode as r, normalizeClass as i, createElementBlock as u, resolveDynamicComponent as p, toDisplayString as c } from "vue";
import { RevButtonBase as F } from "@ds/components/ButtonBase";
import { RevSpinner as G } from "@ds/components/Spinner";
import { RevTag as I } from "@ds/components/Tag";
import { omit as U } from "../../utils/omit.js";
import { tw as t } from "../../utils/tailwind.js";
import { DEFAULT_TAG_VARIANT as B } from "./Picker.constant.js";
const W = {
  key: 0,
  class: "flex w-full flex-col items-center whitespace-normal break-normal"
}, q = { class: "flex" }, H = {
  key: 1,
  class: "flex items-start whitespace-normal break-normal"
}, J = { class: "w-full" }, K = { class: "flex items-baseline justify-between" }, O = "ml-auto body-2 text-static-default-low text-right shrink-0 max-w-[30%]", le = /* @__PURE__ */ D({
  name: "RevPicker",
  inheritAttrs: !1,
  __name: "Picker",
  props: /* @__PURE__ */ N({
    description: { default: "" },
    disabled: { type: Boolean, default: !1 },
    prefix: { default: null },
    prefixProps: { default: () => ({}) },
    label: {},
    loading: { type: Boolean, default: !1 },
    to: { default: () => {
    } },
    tag: { default: "" },
    tracking: { default: () => ({}) },
    rel: { default: "" },
    alignment: { default: "center" },
    details: { default: "" }
  }, {
    modelValue: { type: Boolean },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(l) {
    const n = j(l, "modelValue"), P = a(() => l.to ? "link" : "button"), h = a(() => l.alignment === "center"), f = a(() => n.value && !l.disabled), V = a(() => {
      const e = t`bg-static-default-low focus-visible-outline-default-hi rounded-sm relative flex w-full flex-col justify-center py-12 no-underline motion-safe:transition-colors motion-safe:duration-300 motion-safe:ease-out`, m = t`bg-static-default-low cursor-pointer hover:bg-static-default-low-hover`, b = t`border-action-default-low-pressed`, $ = h.value ? t`px-12` : t`px-16`;
      return [
        !l.disabled && m,
        e,
        $,
        f.value && b
      ];
    }), A = a(() => {
      const e = t` rounded-sm absolute inset-0 motion-safe:transition-colors motion-safe:duration-300 motion-safe:ease-out`, m = t`border-picker border-action-default-low-pressed`, b = t`bg-static-default-low-disabled border-action-default-low-disabled text-static-default-low-disabled cursor-not-allowed focus:outline-none`;
      return [
        l.disabled && b,
        e,
        f.value ? m : "border border-action-default-low"
      ];
    }), S = a(
      () => t`
  absolute left-0 top-1/2 -mt-12 flex w-full place-content-center ${l.disabled ? "text-action-default-hi-disabled" : "text-action-default-hi"}
`
    ), E = a(
      () => t`
  w-full ${l.loading ? "invisible" : ""}
`
    ), k = a(() => [
      t`body-1`,
      l.prefix && t`shrink`,
      l.disabled && t`text-static-default-hi-disabled`,
      n.value ? t`body-1-bold` : t`body-1`,
      f.value && t`text-action-default-hi-pressed`,
      !n.value && !l.disabled && t`text-action-default-hi`
    ]), w = a(() => [
      t`body-2 mt-4`,
      !l.disabled && t`text-static-default-mid`,
      l.disabled && t`text-static-default-hi-disabled`
    ]), x = a(() => U(l.prefixProps, "class")), y = a(() => [
      "mr-8",
      t`h-24 shrink-0`,
      !n.value && !l.disabled && t`text-action-default-hi`,
      f.value && t`text-action-default-hi-pressed`,
      l.disabled && t`text-action-default-hi-disabled`,
      l.prefixProps.class
    ]), R = a(
      () => t`
  absolute ${l.alignment === "left" ? "-top-10 right-12" : "bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2 -rotate-3"}
`
    ), C = a(() => {
      var e;
      return typeof l.tag == "string" ? l.tag : (e = l.tag) == null ? void 0 : e.label;
    }), M = a(
      () => {
        var e;
        return typeof l.tag == "string" ? B : ((e = l.tag) == null ? void 0 : e.variant) ?? B;
      }
    );
    function T() {
      n.value = !n.value;
    }
    return (e, m) => (s(), d(v(F), g(e.$attrs, {
      class: V.value,
      disabled: e.disabled,
      rel: e.rel,
      role: P.value,
      to: e.to,
      tracking: e.tracking,
      onClick: L(T, ["prevent"])
    }), {
      default: z(() => [
        o("div", {
          class: i(S.value)
        }, [
          e.loading ? (s(), d(v(G), {
            key: 0,
            "aria-hidden": ""
          })) : r("", !0)
        ], 2),
        o("div", {
          class: i(A.value)
        }, null, 2),
        o("div", {
          class: i(E.value)
        }, [
          h.value ? (s(), u("div", W, [
            o("div", q, [
              (s(), d(p(e.prefix), g({ class: "" }, x.value, { class: y.value }), null, 16, ["class"])),
              o("span", {
                class: i(k.value)
              }, c(e.label), 3)
            ]),
            e.description ? (s(), u("div", {
              key: 0,
              class: i(w.value)
            }, c(e.description), 3)) : r("", !0)
          ])) : (s(), u("div", H, [
            (s(), d(p(e.prefix), g(x.value, { class: y.value }), null, 16, ["class"])),
            o("div", J, [
              o("div", K, [
                o("p", {
                  class: i(["mr-4 text-left", k.value])
                }, c(e.label), 3),
                e.details ? (s(), u("p", {
                  key: 0,
                  class: i(O)
                }, c(e.details), 1)) : r("", !0)
              ]),
              e.description ? (s(), u("p", {
                key: 0,
                class: i(["text-left", w.value])
              }, c(e.description), 3)) : r("", !0)
            ])
          ]))
        ], 2),
        C.value ? (s(), d(v(I), {
          key: 0,
          class: i(R.value),
          label: C.value,
          variant: M.value
        }, null, 8, ["class", "label", "variant"])) : r("", !0)
      ]),
      _: 1
    }, 16, ["class", "disabled", "rel", "role", "to", "tracking"]));
  }
});
export {
  le as default
};
